var map = {
	"./fonts/NunitoSans/NunitoSans-Regular.ttf": 82,
	"./icons/admin-page.svg": 144,
	"./icons/apple_app-store.svg": 145,
	"./icons/google_play-store.svg": 146,
	"./icons/web-desktop.svg": 147,
	"./logos/applications/AssessmentHub.svg": 148,
	"./logos/applications/Dyalog.svg": 149,
	"./logos/applications/LearningHub.svg": 150,
	"./logos/applications/Odyssey.svg": 151,
	"./logos/applications/Podquest.svg": 152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;